module.exports = {
	"iOS Projects": [
		{
			"name": "Chef Top",
			"links": {
				"app-store": "https://itunes.apple.com/app/chef-top/id1105147301"
			},
			"description": "Chef Top is an app that helps you level up in the kitchen progressively! It doesn't matter if you're a master or a noob: Chef Top will have a challenge for you.",
			"icon": "cheftop.png"
		},
		{
			"name": "Sensorio",
			"links": {
				"app-store": "https://itunes.apple.com/app/sensorio/id1125842321"
			},
			"description": "Sensorio is an universal city guide focused on describing places using a simple language that can be expressed and understood by anyone.",
			"icon": "sensorio.png"
		},
		{
			"name": "apponym",
			"links": {
				"app-store": "https://itunes.apple.com/app/apponym/id1156243203"
			},
			"description": "apponym provides an environment that encourages you to say how you feel – even if you're not okay – and makes it easy to reach out and send good energies to people in need of it!",
			"icon": "apponym.png"
		},
		{
			"name": "perFamily",
			"links": {
				"app-store": "https://itunes.apple.com/br/app/perfamily/id1186376811"
			},
			"description": "perFamily is a tvOS trivia game that puts to test your knowledge about your loved ones. Do you think you know your family? Do you want to know them further? Download perFamily and find out.",
			"icon": "perfamily.png"
		},
		{
			"name": "Molecada",
			"links": {
				"app-store": "https://itunes.apple.com/us/app/molecada/id1234737570"
			},
			"description": "Molecada is a platform that brings traditional child plays back to life in the tvOS. Tradition and technology do not need to be apart from each other!",
			"icon": "molecada.png"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/portfolio.json
// module id = 213
// module chunks = 5